"use client"

// Tracks "did this visit come from clicking a Storehub promotion" so the
// artist can see attributed views/follows, not just raw impressions/clicks.
// sessionStorage, not a server-signed token — good enough for directional
// analytics, not meant to be fraud-proof.

const KEY = "goonru_promo_ref"
const TTL_MS = 30 * 60 * 1000 // 30 minutes — long enough to browse a store and follow, short enough that stale refs don't misattribute later visits

interface PromoReferral {
  promotionId: string
  artistId: string
  setAt: number
}

/** Call right before navigating away from a promo click. */
export function setPromoReferral(artistId: string, promotionId: string) {
  if (typeof window === "undefined") return
  try {
    const ref: PromoReferral = { promotionId, artistId, setAt: Date.now() }
    sessionStorage.setItem(KEY, JSON.stringify(ref))
  } catch {
    // sessionStorage can throw in locked-down browser contexts — attribution is best-effort
  }
}

/** Returns the promotion id if there's a live referral for this artist, else null. */
export function getPromoReferral(artistId: string): string | null {
  if (typeof window === "undefined") return null
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const ref = JSON.parse(raw) as PromoReferral
    if (ref.artistId !== artistId) return null
    if (Date.now() - ref.setAt > TTL_MS) {
      sessionStorage.removeItem(KEY)
      return null
    }
    return ref.promotionId
  } catch {
    return null
  }
}

/** Call after a follow that should still count even if the view was already recorded. */
export function consumePromoReferralForFollow(artistId: string): string | null {
  return getPromoReferral(artistId)
}
